module.exports = __webpack_public_path__ + "media/images/icons/copy-fa73206bcf44bda908372d9d18861748.svg";